// @ts-ignore
import { GandalfArray } from 'gandalf';
// @ts-ignore
import { GandalfConstantDecorator } from 'gandalf';
// @ts-ignore
import { GandalfLabel } from 'gandalf';
// @ts-ignore
import { GandalfModel } from 'gandalf';
// @ts-ignore
import { GandalfModelBase } from 'gandalf';
// @ts-ignore
import { GandalfProperty } from 'gandalf';
// @ts-ignore
import { GandalfSubRequestLabel } from 'gandalf';
// @ts-ignore
import { GandalfValidator } from 'gandalf';
// @ts-ignore
import * as constants from '../constants';


/** See com.rev360.pms.api.controller.prescription.AuthorizeMedicationPrescriptionRequest */
/* istanbul ignore next */
@GandalfModel
export class AuthorizeMedicationPrescriptionRequest extends GandalfModelBase {

	@GandalfValidator({ notNull: { message: 'Medication Prescription is required' } })
	@GandalfProperty({ designType: Number, isRequired: true })
	medicationPrescriptionId!: number;

	@GandalfValidator({ notNull: { message: 'Use Provider Signature is required' } })
	@GandalfProperty({ designType: Boolean, isRequired: true })
	useProviderSignature!: boolean;

}
